export const FormFieldset = {
  bindings: {
    key: '@',
    type: '@',
    form: '<',
    list: '<',
    name: '<',
    onUpdate: '&',
  },

  template: `
    <fieldset class="form-group preference-answer">
      <ul class="d-flex flex-wrap list-inline m-0">
        <li class="col-4 col-lg-2 col-md-3 col-sm-3 px-1 m-0 list-inline-item text-center"
          ng-repeat="item in $ctrl.list track by $index">
          <form-label-checkbox
            active="item.active"
            value="item"
            name="$ctrl.name"
            on-click="$ctrl.onClick($ctrl.list, $index)">
            <i class="d-block fa fa-3x icon-voome-flame"
              ng-class="{
                'text-gray-lighter': !item.active,
                'text-white': item.active
              }">
            </i>
            <small ng-class="{ 'text-white': item.active }">
              {{ item.name }}
            </small>
          </form-label-checkbox>
        </li>
      </ul>
    </fieldset>`,

  controller() {
    return {
      onClick(list, index) {
        const value =
          this.type === 'checkbox'
            ? this.asCheckbox(list, index)
            : this.asRadio(list, index);

        this.onUpdate({ key: this.key, value });
      },

      asCheckbox(list, $index) {
        return list.map((item, index) => {
          return index === $index ? { ...item, active: !item.active } : item;
        });
      },

      asRadio(list, $index) {
        return list.map((item, index) => {
          return { ...item, active: index === $index ? !item.active : false };
        });
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/FormElements/FormFieldset.js